<template>
	<div>
    <modalSerial ref="modalSerial" :type="serial_type" :name="product_name" :quantity="quantity" @saveSerial="saveSerial"/>
		<!-- <v-row justify="center"> -->
			<v-dialog v-model="dialog" persistent max-width="900" scrollable>
				<v-form ref="formApproval" role="form" v-on:submit.prevent="approveData">
					<!-- <v-card-text> {{ serial_type }} </v-card-text> -->
					<v-card>
						<v-card-title class="text-h6">
							<span>Persetujuan Klaim Produk Recall</span>
						</v-card-title>
						<v-card-text class="black--text">
							<v-row class="mb-3">
								<v-col cols="6" md="6">
									<div class="text-subtitle-1 font-weight-bold">Data Transaksi</div>
									<div class="pt-1">{{ val.recall_claim_tr_code }}</div>
									<div class="pt-1">{{ val.recall_claim_mid }}</div>
									<div class="pt-1">{{ val.recall_claim_bv }} BV</div>
								</v-col>
								<v-col cols="6" md="6">
									<div class="text-subtitle-1 font-weight-bold">Data Pengambilan</div>
									<div class="pt-1">{{ val.recall_claim_type_label }}</div>
									<div class="pt-1" v-if="val.recall_claim_type == '1'">{{ val.recall_claim_address }}</div>
									<div class="pt-1" v-if="val.recall_claim_type == '1'">{{ val.recall_claim_hp }}</div>
								</v-col>
							</v-row>
						</v-card-text>
						<v-card-text class="black--text" v-if="dialogType == 'approve'">
							<v-row>
								<v-col cols="12">
									<v-alert v-for="(alert, index) in alertMultiple" v-model="alert.show" :key="index" dismissible type="error" elevation="1">
										{{alert.message}}
									</v-alert>
									<v-simple-table class="white-row" no-data-text="Belum ada data tersedia">
										<template v-slot:default>
											<thead class="v-data-table-header">
												<tr>
													<th width="5%" class="text-left">Aksi</th>
													<th width="25%" class="text-left">Nama Produk</th>
													<th class="text-right">BV Recall</th>
													<th class="text-left">Jumlah</th>
													<th class="text-right">Subtotal BV</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(product, index) in productsSelected" :key="product.product_id">
													<td>
														<v-tooltip bottom>
															<template v-slot:activator="{ on, attrs }">
																<v-btn class="" fab dark x-small depressed color="pink" v-bind="attrs" v-on="on" @click.stop="deletefromProduct(index)">
																	<v-icon dark>mdi-delete</v-icon>
																</v-btn>
															</template>
															<span>Hapus</span>
														</v-tooltip>
													</td>
													<td>
														<v-autocomplete :items="productsNotSelected" :filter="customFilter" return-object item-text="product_name" placeholder="Pilih Produk" v-model="product.data" no-data-text="Tidak ada data yang sesuai" :rules="[productRules]" class="py-2 details-mb-0 width-0" outlined dense hide-details="auto" background-color="white">
															<template v-slot:item = {item}>
																{{item.product_code}} - {{item.product_name}} ({{item.product_unit}})
															</template>
															<template v-slot:selection = {item}>
																{{item.product_name}}
															</template>
														</v-autocomplete>
													</td>
													<td class="text-right"> {{ product.data.product_is_serial_bv | toNumber }} </td>
													<td>
														<v-currency-field v-model="product.data.quantity" :rules="[inputrules.required, inputrules.notnull]" class="py-2 details-mb-0" outlined dense hide-details="auto" background-color="white"></v-currency-field>
													</td>
													<td class="text-right"> {{ product.data.product_is_serial_bv * product.data.quantity | toNumber }} </td>
												</tr>
											</tbody>
											<tfoot v-if="productsSelected.length > 0">
												<tr>
													<td colspan="3" class="font-weight-bold"></td>
													<td class="font-weight-bold">Total BV</td>
													<td>
														<div class="font-weight-bold text-right"> {{ calculateTotal | toNumber }} </div>
													</td>
												</tr>
												<tr>
													<td colspan="3" class="font-weight-bold"></td>
													<td class="font-weight-bold">Maksimum BV</td>
													<td>
														<div class="font-weight-bold text-right"> {{ val.recall_claim_bv | toNumber }} </div>
													</td>
												</tr>
											</tfoot>
										</template>
									</v-simple-table>
								</v-col>
								<v-col cols="12" class="pt-0">
									<v-btn light depressed color="primary" @click="addProduct">
										<v-icon>mdi-plus-circle</v-icon>
										<div class="pl-2 text-capitalize">Tambah Produk</div>
									</v-btn>
								</v-col>
							</v-row>
						</v-card-text>
						<v-card-text class="black--text" v-if="dialogType == 'detail'">
							<v-row>
								<v-col cols="12">
									<v-simple-table class="white-row" no-data-text="Belum ada data tersedia">
										<template v-slot:default>
											<thead class="v-data-table-header">
												<tr>
													<th width="25%" class="text-left">Nama Produk</th>
													<th class="text-right">BV Recall</th>
													<th class="text-right">Jumlah</th>
													<th class="text-right">Subtotal BV</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(product) in detailProduct.detail" :key="product.recall_claim_approval_detail_id">
													<td> {{ product.recall_claim_approval_detail_product_name }} </td>
													<td class="text-right"> {{ product.recall_claim_approval_detail_product_bv | toNumber }} </td>
													<td class="text-right"> {{ product.recall_claim_approval_detail_quantity | toNumber }} </td>
													<td class="text-right"> {{ product.recall_claim_approval_detail_product_bv * product.recall_claim_approval_detail_quantity | toNumber }} </td>
												</tr>
											</tbody>
											<tfoot v-if="detailProduct.detail.length > 0">
												<tr>
													<td colspan="2" class="font-weight-bold"></td>
													<td class="font-weight-bold">Total BV</td>
													<td>
														<div class="font-weight-bold text-right"> {{ detailProduct.recall_claim_approval_total_bv | toNumber }} </div>
													</td>
												</tr>
												<tr>
													<td colspan="2" class="font-weight-bold"></td>
													<td class="font-weight-bold">Maksimum BV</td>
													<td>
														<div class="font-weight-bold text-right"> {{ detailProduct.recall_claim_bv | toNumber }} </div>
													</td>
												</tr>
											</tfoot>
										</template>
									</v-simple-table>
								</v-col>
							</v-row>
						</v-card-text>
						<v-card-actions v-if="dialogType == 'approve'">
							<v-spacer></v-spacer>
							<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Batal</v-btn>
							<v-btn color="primary darken-1" depressed class="text-capitalize" type="submit" :disabled="productsSelected.length == 0 || calculateTotal > val.recall_claim_bv">Proses</v-btn>
						</v-card-actions>
						<v-card-actions v-if="dialogType == 'detail'">
							<v-spacer></v-spacer>
							<v-btn color="grey darken-1" outlined class="text-capitalize" @click="hideDialog">Batal</v-btn>
						</v-card-actions>
					</v-card>
				</v-form>
			</v-dialog>
		<!-- </v-row> -->
	</div>
</template>

<script>
import {mapActions, mapState, mapMutations} from 'vuex'
import modalSerial from '@/views/MLwarehouse/productRecall/modalSerial'

export default {
	inject: ['theme'],
	components:{
		modalSerial,
	},
	data () {
		return {
			productsSelected: [],
			productRules: value => !!value.product_id || 'Tidak boleh kosong',
			page: 1,
			serial_type: [],
			card_type: '',
			product_name: '',
			quantity: 0,
			product_id: '',
		}
	},
	computed:{
		...mapState('productRecall', ['listProduct', 'response', 'responseError', 'alertMultiple']),
		calculateTotal(){
			let total = 0
			this.productsSelected.forEach( (el) => {
				//console.log(el)
				total += el.data.product_is_serial_bv * el.data.quantity
			});

			return total
		},
		productsNotSelected() {
			if (this.productsSelected.length > 0) {
				const productSelected = this.productsSelected.map((el) => el.data)
				return this.listProduct.map((el) => {
					if (productSelected.includes(el)) {
						el.disabled = true
					} else {
						el.disabled = false
					}
					return el
				})
			}
			return this.listProduct
		},
	},
	created() {
		this.getOptionProduct({limit:100})
	},
	props: {
		dialog: Boolean,
		val: Object,
		dialogType: String,
		detailProduct: Object,
	},
	methods :{
		...mapActions('productRecall', ['getOptionProduct','approveProductRecall','getDataProductRecall']),
		...mapMutations('productRecall', ['saveResponse','clearDataApprovalRecall']),
		hideDialog(){
			this.$emit('hideDialog')
			this.resetForm()
		},
		addProduct() {
			//this.responseError.product = ''
			this.productsSelected.push({
				data: {
					product_id: '',
					product_name: '',
					quantity: '0',
					product_is_serial_bv: '0',
					card_type: '',
					serial: [],
				},
			})
		},
		customFilter (item, queryText) {
			const textOne = item.product_code.toLowerCase()
			const textTwo = item.product_name.toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 ||
			textTwo.indexOf(searchText) > -1
		},
		deletefromProduct(index){
			this.productsSelected.splice(index, 1)
		},
		resetForm(){
			this.saveResponse({})
			this.productsSelected = []
			this.$refs.formApproval.resetValidation()
		},
		async approveData(){
			if (this.$refs.formApproval.validate() && this.productsSelected.length > 0) {
				await this.approveProductRecall({
					id: this.val.recall_claim_id,
					status: 1,
					products: this.productsSelected,
					total_bv: this.calculateTotal
				}).then( () => {
					if(this.response.code == 200) {
						this.getDataProductRecall(this.queryString({limit:this.limit, page: this.page, params:this.params, sort: this.sortBy, dir: this.sortDir}))
						//this.dialog = false
						//this.resetForm()
						this.hideDialog();
					}
				})
			}
		},
		// async processApproval(){
		// 	await this.setOverlay(true)
		// 	await this.$refs.modalconfirmApproveRecall.hideConfirm()
		// }
		showModalSerial(item){
			//console.log(JSON.parse(item.product_is_serial))
			if (item.card_type) {
				this.serial_type = JSON.parse(item.product_is_serial)

				this.card_type = item.card_type
				this.product_id = item.product_id
				this.quantity = item.quantity
				this.product_name = item.product_name
				this.$refs.modalSerial.showModal()
				// this.$refs.ModalAddSerial.updateSerial(item.serial)
			}
		},
		async saveSerial(serial_data) {
			//console.log(serial_data)

			// define index product
			let indexProduct = await this.detailSO.so_detail.findIndex(el => el.so_detail_product_id == this.product_id);
			
			let serialArray = []
			await this.detailSO.so_detail.forEach( el => {
				
				if (el.so_detail_product_is_serial != null) {
					el.so_detail_product_is_serial.forEach(serial => {
						if (serial.type_id == serial_data.type_id) {
							serialArray = [... serialArray, ... serial.serial_array]
						}
					})
				}	
			});

			await this.scanSerial({
				serial: serial_data.serial,
				type: serial_data.type_id,
				card_type: this.card_type
			}).then((serial) => {
				let serialSuccess = serial.success.filter(el => {
					return !serialArray.includes(el)
				})
				
				// set product based on index
				let product = this.detailSO.so_detail[indexProduct]

				// find index serial
				let indexSerial = product.so_detail_product_is_serial.findIndex(el => {
					return el.type_id == serial_data.type_id
				});

				// define dataSerial by index serial
				let dataSerial = product.so_detail_product_is_serial[indexSerial]

				// set total serial needed
				let serial_needed = product.so_detail_quantity_remaining * serial_data.quantity

				// define serial to save
				let unique = new Set([... dataSerial.serial_array, ... serialSuccess])
				if (serial_needed >= (dataSerial.serial_array.length + serialSuccess.length)) {
					dataSerial.serial_array = [... unique]
					this.detailSO.so_detail[indexProduct].so_detail_product_is_serial[indexSerial].serial_array = dataSerial.serial_array
					this.setSnackbar({
						show: true,
						color: 'success',
						text: `Berhasil scan serial`
					})
				} else {
					if (serialSuccess.length > 0) {
						dataSerial.serial_array = [... unique]
						this.detailSO.so_detail[indexProduct].so_detail_product_is_serial[indexSerial].serial_array = dataSerial.serial_array.slice(0, serial_needed)
						this.setSnackbar({
							show: true,
							color: 'red darken-2',
							text: `Jumlah serial yang diproses disesuaikan`
						})
					} else {
						this.setSnackbar({
							show: true,
							color: 'red darken-2',
							text: 'Gagal scan serial'
						})
					}
				}

				var alert = []
				for (let variable in serial.failed) {
					var msg = '';
					msg += serial.failed[variable].join(', ')
					msg += ` ${variable}`
					alert.push({
						msg: msg,
						show: true
					})
				}
				this.$refs.ModalAddSerial.showMessage(alert)
			}).catch((serial) => {
				var alert = []
				for (let variable in serial.failed) {
					var msg = '';
					msg += serial.failed[variable].join(', ')
					msg += ` ${variable}`
					alert.push({
						msg: msg,
						show: true
					})
				}
				this.$refs.ModalAddSerial.showMessage(alert)
				this.setSnackbar({
					show: true,
					color: 'red darken-2',
					text: 'Gagal scan serial'
				})
			})
		},
	},
	beforeDestroy(){
		this.clearDataApprovalRecall()
	},
	watch: {
		dialog() {
			//console.log(this.val)
		}
	}
};
</script>
